export default __webpack_public_path__ + "static/media/product-2.c2f6f901.jpg";